<template>
  <div class="header-signature">
    <img :src="logoImage" alt="Kas" />
  </div>
</template>

<script>
import Logo from './_images/signature.svg'
export default {
  name: 'TheHeaderSignature',
  data () {
    return {
      logoImage: Logo
    }
  }
}
</script>

<style lang="scss">
.header-signature{
  max-width: 11rem;
  opacity: 1;

  img{
    width: 100%;
  }
}
</style>
